<template>
  <div
    class="
      min-height
      user-list-main-wrapper
      cbg-white-container
      theme--light
      v-card
      user-list-wrap-box
    "
  >
    <CCol sm="12" class="pt-0">
      <v-form ref="createForm">
        <v-row class="my-0 pt-3 pb-3">
          <div class="col-md-4 col-sm-6 col-xs-12 import-user-column">
            <label for>Select User</label>
            <v-autocomplete
              v-model="user"
              :items="items"
              :loading="isLoading"
              :search-input.sync="search"
              hide-no-data
              item-text="full_name"
              item-value="_id"
              label="Search User"
              return-object
              outlined
              class="import-combo"
            ></v-autocomplete>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12 import-user-first-name">
            <label for>First Name</label>
            <input
              type="text"
              v-model="user.first_name"
              class="form-control"
              readonly
            />
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <label for>Middle Name</label>
            <input
              type="text"
              v-model="user.middle_name"
              class="form-control"
            />
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <label for>Last Name</label>
            <input
              type="text"
              v-model="user.last_name"
              class="form-control"
              readonly
            />
          </div>

          <div
            class="
              col-md-4 col-sm-6 col-xs-12
              datepicker
              pos-r
              import-datepicker
              position-relative
            "
          >
            <label class="col-sm-12 text-left nopad pl-0 pr-0 pb-0 pt-0"
              >Date Of Birth</label
            >
            <Datepicker class="block h-full w-100" v-model="user.dob">
              <template v-slot="{ inputValue, togglePopover }">
                <div class="flex items-center w-100">
                  <input
                    :value="inputValue"
                    placeholder="DD/MM/YYYY"
                    class="
                      bg-white
                      text-gray-700
                      border-radius
                      w-100
                      py-1
                      px-2
                      appearance-none
                      border
                      rounded-r
                      focus:outline-none focus:border-blue-500
                    "
                    readonly
                  />
                </div>
                <div
                  @click.prevent="togglePopover()"
                  class="calendarsvg userinputcalendar pos-a"
                >
                  <calendarSVG />
                </div>
              </template>
            </Datepicker>

            <!-- <datepicker
              v-model="date"
              @input="dateChange()"
              ref="datepicker"
              :masks="{ input: 'DD/MM/YYYY' }"
            >
            </datepicker>
            <div class="calendarsvg userinputcalendar pos-a">
              <calendarSVG />
            </div>-->
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <label for>Age</label>
            <input type="text" v-model="user.age" class="form-control" />
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <label for>Gender</label>
            <select v-model="user.gender" class="form-control" id>
              <option value>-- Select Gender --</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
            <label for>Phone Number</label>
            <input
              type="text"
              v-model="user.mobile"
              class="form-control"
              readonly
            />
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12 csv-input-box csv-no-file">
            <label for>Select Csv</label>
            <p class="choosen-label position-absolute">No File Choosen</p>
            <span class="selected-label position-absolute">{{
              centerCSV
            }}</span>
            <input
              type="file"
              class="border-radius custom-file-input"
              accept=".csv"
              @change="uploadFile"
              id="uploadCaptureInputFile"
            />
          </div>
        </v-row>
        <v-row class="pl-3 pr-3 pb-5">
          <v-btn
            color="success"
            :disabled="loading"
            @click="createCenter"
            class="mr-3"
            >Create Centers</v-btn
          >
          <v-btn color="default" @click="clearfields">Reset</v-btn>
        </v-row>
      </v-form>
    </CCol>
    <div class="d-flex mb-4 mt-2 d-just-space mr-3">
      <v-btn type="button" class="ml-3" @click="getFailedJobs">Refresh</v-btn>
      <v-btn type="button" class="ml-3" @click="getFailedJobsCsv">Export</v-btn>
      <div class="d-flex">
        <v-btn type="button" class="ml-3 mr-3" @click="retryAll"
          >Retry All</v-btn
        >
        <h2 class="pl-4">Total Failed Jobs : {{ this.failedJobs.length }}</h2>
      </div>
    </div>
    <div class="overflow-auto">
      <table class="table userlistTable table-width">
        <thead>
          <tr class="table-success">
            <!-- 0 -->
            <!-- <th scope="col" class="min-width-120">User Name</th> -->
            <!-- 1 -->
            <th scope="col">Center Name</th>
            <th scope="col">Center city</th>
            <th scope="col">Center pincode</th>
            <th scope="col">Center contact</th>
            <th scope="col">Attemps</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(jobs, index) in failedJobs" :key="index">
            <!-- <td class="text-capitalize">{{jobs.payload.jobName}}</td> -->
            <td class="text-capitalize">
              {{
                jobs.payload.parameter.center.name
                  ? jobs.payload.parameter.center.name
                  : "-"
              }}
            </td>
            <td class="text-capitalize">
              {{
                jobs.payload.parameter.center.city
                  ? jobs.payload.parameter.center.city
                  : "-"
              }}
            </td>
            <td class="text-capitalize">
              {{
                jobs.payload.parameter.center.pincode
                  ? jobs.payload.parameter.center.pincode
                  : "-"
              }}
            </td>
            <td class="text-capitalize">
              {{
                jobs.payload.parameter.center.contact_number
                  ? jobs.payload.parameter.center.contact_number
                  : "-"
              }}
            </td>
            <td class="text-capitalize">{{ jobs.tries }}</td>
            <td class="text-capitalize">
              <v-btn type="button" @click="retry(jobs._id)">Retry</v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template> 
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import Swal from "sweetalert2";
import FileUpload from "@/components/FileUpload.vue";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import debounce from "lodash/debounce";
export default {
  components: {
    Datepicker,
    FileUpload,
    ...pickSvg("crossSVG", "verticalDotsSVG"),
  },
  data() {
    return {
      dayJS,
      user: {},
      centerType: this.$route.params.center_type,
      items: [],
      isLoading: false,
      search: null,
      centerCSV: null,
      loading: false,
      date: new Date(),
      estimated_dob: null,
      failedJobs: [],
    };
  },
  mounted() {
    this.getFailedJobs();
  },
  watch: {
    search(val) {
      this.getUsers(val);
    },
    "user.dob": function (newValue) {
      if (newValue) {
        this.calculateAge();
      }
    },
  },
  methods: {
    getUsers: debounce(function (search) {
      if (!search) this.items = [];
      let url = `${config.BASE_URL}api/v2/admin/role-wise-user?role=${this.centerType}&search=${search}`;
      this.$http.get(url).then((response) => {
        this.items = response.body.data;
      });
    }, 500),
    uploadFile(e) {
      this.centerCSV = e.target.files;
    },
    calculateAge() {
      let estimated_dob = this.dayJS().diff(this.user.dob, "years");
      this.user.age = estimated_dob;
    },
    clearfields() {
      this.search = null;
      this.centerCSV = null;
      this.user.first_name = "";
      this.user.last_name = "";
      this.user.gender = "";
      this.user.mobile = "";
      this.user.dob = "";
      this.user.age = "";
      document.getElementById("uploadCaptureInputFile").value = "";
    },
    getFailedJobs() {
      let url = `${config.BASE_URL}api/v2/admin/failed-jobs/CreateCenterJob`;
      let params = {};
      this.$http.get(url, { params }).then((res) => {
        if (res.status) {
          this.failedJobs = res.data.data;
        }
      });
    },
    
    getFailedJobsCsv() {
      let url = `${config.BASE_URL}api/v2/admin/failed-jobs-csv/CreateCenterJob`;
      let params = {};
      this.$http.get(url, { params }).then((res) => {
        if (res.status) {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(
            new Blob(["\ufeff", res.body])
          );
          downloadLink.download = "centeruploadFailed.csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      });
    },
    createCenter() {
      if (this.centerCSV !== null && this.user.first_name && this.user.gender) {
        this.loading = true;
        const formData = new FormData();
        for (const i of Object.keys(this.centerCSV)) {
          formData.append("center_csv", this.centerCSV[i]);
        }

        formData.set("id", this.user._id);
        formData.set("middle_name", this.user.middle_name);
        formData.set("gender", this.user.gender);

        if (!this.user.dob && this.user.age) {
          formData.set(
            "estimated_dob",
            dayJS().subtract(this.user.age, "years").format("YYYY-MM-DD")
          );
        } else {
          formData.set("dob", this.user.dob);
        }

        formData.set("center_type", this.centerType);

        this.$http
          .post(`${config.BASE_URL}api/v2/admin/import-centers`, formData, {})
          .then(
            (response) => {
              this.loading = false;
              Swal.fire({
                title: "Centre Created",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.clearfields();
                }
              });
            },
            (err) => {
              this.loading = false;
              console.log(err);
            }
          );
      } else {
        Swal.fire({
          title: "All feilds are required",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      }

      this.loading = false;
    },

    retry(id) {
      this.$http.post(`${config.BASE_URL}api/v2/admin/retry-jobs/` + id).then(
        (response) => {
          this.getFailedJobs();
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
    },
    retryAll() {
      this.$http
        .post(`${config.BASE_URL}api/v2/admin/retry-all-jobs/CreateCenterJob`)
        .then(
          (response) => {
            this.getFailedJobs();
          },
          (err) => {
            this.loading = false;
            console.log(err);
          }
        );
    },
  },
};
</script>
